module.exports = __webpack_public_path__ + "img/face-sad-cry.363277f0.svg";